import { create } from 'zustand'
import { isVisitorAccessEnabled } from '@/lib/visitor-access'

interface VisitorState {
  /** Indica se está em modo visitante (não autenticado, mas com acesso permitido) */
  isVisitorMode: boolean
  /** Indica se o modal de login está aberto */
  showLoginModal: boolean
  /** Motivo pelo qual o modal foi aberto */
  loginModalReason: string | null
  /** Path para redirecionar após login bem-sucedido */
  redirectAfterLogin: string | null
  /** Ação pendente para executar após login */
  pendingAction: (() => void) | null

  // Actions
  setVisitorMode: (value: boolean) => void
  openLoginModal: (reason?: string, redirectPath?: string) => void
  closeLoginModal: () => void
  clearRedirect: () => void
  setPendingAction: (action: (() => void) | null) => void
  executePendingAction: () => void
}

export const useVisitorStore = create<VisitorState>((set, get) => ({
  isVisitorMode: false,
  showLoginModal: false,
  loginModalReason: null,
  redirectAfterLogin: null,
  pendingAction: null,

  setVisitorMode: (value: boolean) => {
    set({ isVisitorMode: value })
  },

  openLoginModal: (reason?: string, redirectPath?: string) => {
    set({
      showLoginModal: true,
      loginModalReason: reason || null,
      redirectAfterLogin: redirectPath || null,
    })
  },

  closeLoginModal: () => {
    set({
      showLoginModal: false,
      loginModalReason: null,
    })
  },

  clearRedirect: () => {
    set({ redirectAfterLogin: null })
  },

  setPendingAction: (action: (() => void) | null) => {
    set({ pendingAction: action })
  },

  executePendingAction: () => {
    const { pendingAction } = get()
    if (pendingAction) {
      pendingAction()
      set({ pendingAction: null })
    }
  },
}))

/**
 * Hook para verificar se visitantes são permitidos baseado na configuração do tema
 * Deve ser usado em conjunto com useThemeStore
 */
export const checkVisitorAllowed = isVisitorAccessEnabled
